export interface AbstractSection {
  heading: string
  content: string
}

export interface ParsedAbstract {
  sections: AbstractSection[]
  hasMath: boolean
}

const SECTION_HEADINGS = [
  'BACKGROUND',
  'OBJECTIVE',
  'OBJECTIVES',
  'METHODS',
  'METHOD',
  'RESULTS',
  'RESULT',
  'CONCLUSIONS',
  'CONCLUSION',
  'DISCUSSION',
  'INTRODUCTION',
  'PURPOSE',
  'SIGNIFICANCE',
  'SUMMARY',
]

// Detects inline LaTeX: $...$ or $$...$$ or \(...\) or \[...\]
const MATH_RE = /\$\$.+?\$\$|\$.+?\$|\\\(.+?\\\)|\\\[[\s\S]+?\\\]/

export function parseStructuredAbstract(text: string): ParsedAbstract {
  const hasMath = MATH_RE.test(text)

  // Split on section headings — keep delimiters via capture group
  const parts = text.split(new RegExp(`(${SECTION_HEADINGS.join('|')})[.:]\\s*`, 'i'))

  // If no section headings found, return as single unheaded section
  if (parts.length === 1) {
    return { sections: [{ heading: '', content: text.trim() }], hasMath }
  }

  const sections: AbstractSection[] = []

  // parts = [pre-text, heading, content, heading, content, ...]
  const preamble = parts[0].trim()
  if (preamble) {
    sections.push({ heading: '', content: preamble })
  }

  for (let i = 1; i < parts.length; i += 2) {
    const heading = parts[i]?.toUpperCase() ?? ''
    const content = (parts[i + 1] ?? '').trim()
    if (heading) {
      sections.push({ heading, content })
    }
  }

  return { sections, hasMath }
}
